import {
  createStandaloneToast,
  UseToastOptions,
  theme,
} from '@cdl/heartbeat-react';
import { defaultToastOptions } from '../../styleguide/theme';

type props = Pick<
  UseToastOptions,
  'title' | 'description' | 'duration' | 'status'
>;

// Display notification outside react component
export const displayNotification = (options: props) => {
  const { toast } = createStandaloneToast({
    theme,
    defaultOptions: defaultToastOptions,
  });

  toast(options);
};
